import React, { useState } from 'react';
import './ShareLink.scss';
import PropTypes from 'prop-types';
import { Share2 as ShareIcon } from 'react-feather';
import { classNames } from 'utils';
import ShareModal from './ShareModal';
import { Button } from 'ui-kit';

const ShareLink = ({ className, text, withIcon, inline, color, storeId, variant }) => {
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);

  const handleShareModalOpen = () => {
    setIsShareModalOpen(true);
  };

  const handleShareModalClose = () => {
    setIsShareModalOpen(false);
  };

  return (
    <span className={classNames(className, inline ? 'inline' : '')}>
      <Button
        variant={variant}
        className={classNames(className, 'ShareLink_button')}
        color={color}
        onClick={handleShareModalOpen}
        endIcon={withIcon && <ShareIcon />}
      >
        <span className="controlText">{text}</span>
      </Button>
      <ShareModal storeId={storeId} isOpen={isShareModalOpen} onClose={handleShareModalClose} />
    </span>
  );
};

ShareLink.propTypes = {
  className: PropTypes.string,
  storeId: PropTypes.number.isRequired,
  text: PropTypes.string,
  withIcon: PropTypes.bool,
  inline: PropTypes.bool,
  color: PropTypes.string,
  variant: PropTypes.oneOf(['text', 'contained', 'outlined']),
};

ShareLink.defaultProps = {
  text: 'Share',
  color: 'plain-white',
  variant: 'text',
};

export default ShareLink;
